import {
    TIMESTAMP_FORMAT,
    DATETIME_FORMAT,
} from 'commons/js/constants'

import {
    parseMoment,
} from 'commons/js/util/dateConverter'

import {
    getPlace,
    getStart,
    getEnd,
} from './searchLenses'

export default function buildSearchParams ({ search, filters }) {
    const place = getPlace(search)
    return {
        airport_id: place.airport_id || '',
        poi_id: place.poi_id || '',
        place_id: place.place_id,
        start_date: getStart(search)
            ? parseMoment(getStart(search), TIMESTAMP_FORMAT).format(DATETIME_FORMAT)
            : undefined,
        end_date: getEnd(search)
            ? parseMoment(getEnd(search), TIMESTAMP_FORMAT).format(DATETIME_FORMAT)
            : undefined,
        'parking_type[airport]': filters.parkingType.airport,
        'parking_type[mowiztruck]': filters.parkingType.onlyMowizTruck,
        'parking_provider[aena]': filters.parkingProvider.aena,
        'booking_service[airport_transfer]': filters.bookingService.airportTransfer,
        'booking_service[pick_up]': filters.bookingService.pickUp,
        'booking_service[walking]': filters.bookingService.walking,
    }
}
